import { resolveIdNotOAuthPublicBaseUrl } from "./idNotOAuthPublicBaseUrl";

/**
 * Validated `returnTo` from sessionStorage (same rules as IdNot authorize redirect).
 */
export function readIdNotReturnToFromSessionStorage(): string | null {
	if (typeof sessionStorage === "undefined") {
		return null;
	}
	try {
		const returnTo = sessionStorage.getItem("idnot_returnTo");
		if (!returnTo) {
			return null;
		}
		const isValidReturnTo = returnTo.startsWith("/") && !returnTo.startsWith("//");
		if (!isValidReturnTo) {
			return null;
		}
		return returnTo;
	} catch {
		return null;
	}
}

/**
 * OAuth `redirect_uri` value: must match between IdNot authorize and token exchange.
 */
export function buildIdNotOAuthRedirectUri(appHost: string, returnTo: string | null): string {
	const callbackPath = returnTo ? `/authorized-client?returnTo=${encodeURIComponent(returnTo)}` : "/authorized-client";
	return new URL(callbackPath, appHost).toString();
}

/**
 * Current browser public origin + optional `returnTo` (sessionStorage).
 */
export function buildBrowserIdNotOAuthRedirectUriForTokenExchange(): string {
	const appHost = resolveIdNotOAuthPublicBaseUrl();
	const returnTo = readIdNotReturnToFromSessionStorage();
	return buildIdNotOAuthRedirectUri(appHost, returnTo);
}
